const users = (state = null, action) => {
  switch (action.type) {
    case 'LOAD_USERS':
      let users = {}
      action.snapshot.docs.forEach(doc => {
        users[doc.id] = doc.data()
        users[doc.id].displayName = doc.data().nickName? doc.data().nickName : doc.data().realName
      })
      return users

    default:
      return state
  }
}
export default users



// WEBPACK FOOTER //
// ./src/reducers/users.js